import { GitFork } from 'lucide-react';
import { CartaoDoNo, EntradaDoNo } from './node-chrome';
import { SaidaNomeada } from './node-saida';

/**
 * Rótulos das condições de e-mail, que vêm do construtor de fluxos de e-mail
 * e não têm equivalente no resumo genérico de WhatsApp.
 */
const CONDICAO_DE_EMAIL: Record<string, (d: any) => string> = {
  opened: (d) => `Se abriu o e-mail em até ${d.windowHours ?? 24}h`,
  email_opened: (d) => `Se abriu o e-mail em até ${d.windowHours ?? 24}h`,
  clicked: (d) => `Se clicou no link em até ${d.windowHours ?? 24}h`,
  email_clicked: (d) => `Se clicou no link em até ${d.windowHours ?? 24}h`,
  open_count: (d) => `Se abriu ${d.minCount ?? 2}+ vezes em ${d.windowHours ?? 24}h`,
  email_open_count: (d) => `Se abriu ${d.minCount ?? 2}+ vezes em ${d.windowHours ?? 24}h`,
  score: (d) => `Se o score ${d.scoreOperator === 'lte' || d.scoreOperator === 'lt' ? 'for até' : 'passar de'} ${d.scoreValue ?? 50}`,
  score_total: (d) => `Se o score passar de ${d.scoreValue ?? 50}`,
  composite: (d) =>
    `${Array.isArray(d.subConditions) ? d.subConditions.length : 0} regras combinadas com ${(d.compositeMode ?? 'and') === 'and' ? 'E' : 'OU'}`,
};

export default function ConditionNode({ data }: any) {
  const especial = CONDICAO_DE_EMAIL[String(data.conditionType ?? '')];
  return (
    <>
      <EntradaDoNo />
      <CartaoDoNo
        tipo="condition"
        dados={data}
        icone={GitFork}
        corDoTopo="bg-yellow-500"
        corDoIcone="text-yellow-600"
        titulo={data.label || 'Dividir por condição'}
        resumo={especial ? especial(data) : undefined}
        largura="w-[240px]"
      >
        <div className="mt-2 border-t border-border/40 pt-1.5">
          <SaidaNomeada id="true" rotulo="Sim" cor="verde" />
          <SaidaNomeada id="false" rotulo="Não" cor="vermelho" />
        </div>
      </CartaoDoNo>
    </>
  );
}
